import React from 'react';
import {
    formatter, formatterCurrency, BASE_CURRENCY
} from "../../../../utils/common";

const Widget = ({ textColorClass, value, label, isShowSale, saleValue, isShowReturn, returnValue, isShowSubValue, subValue, subSaleValue, subReturnValue }) => {
    textColorClass = textColorClass ? textColorClass : 'text-dark';
    return (
        <div className="col-md-6 col-xl" style={{ padding: 6 }}>
            <div className="summary-box">
                <div className="summary-box-body text-right">
                    <h6 className="text-truncate sb-title">{label}</h6>
                    <h5 className={`sm-value ${textColorClass}`}>{value}</h5>

                    {isShowSubValue ? (                    
                    <h6 className="card-box-sub-value">{subValue}</h6>
                    ) : null}
                </div>

                {(isShowSale || isShowReturn) && (
                    <div className="summary-box-footer">
                        {isShowSale ? (
                            <div className="sbf-item sbf-item-left text-center">
                                <small className="text-muted">Sale</small>
                                <div className="font-weight-bold">{saleValue}</div>

                                {isShowSubValue ? (                    
                                <h6 className="card-box-sub-value">{subSaleValue}</h6>
                                ) : null}
                            </div>
                        ) : null}

                        {isShowReturn ? (
                            <div className="sbf-item sbf-item-right text-center">
                                <small className="text-muted">Return</small>
                                <div className="font-weight-bold">{returnValue}</div>

                                {isShowSubValue ? (                    
                                <h6 className="card-box-sub-value">{subReturnValue}</h6>
                                ) : null}
                            </div>
                        ) : null}
                    </div>
                )}
            </div>
        </div>
    );
};

const DiscountTotalSummary = ({ financesSummaryState }) => {
    const totalRow = financesSummaryState.discountDetailsTableRow;
    const totalSummary = financesSummaryState.discountDetailsTableSummary;
    const currency = totalSummary && totalSummary.currency ? totalSummary.currency : null;

    const widgetsData = [
        {
            value: totalRow,
            label: "Total Records",
            isShowSale: true,
            isShowReturn: true,
            saleValue: totalSummary ? totalSummary.total_sales_count : 0,
            returnValue: totalSummary ? totalSummary.total_return_count : 0,
        },
        {
            textColorClass: 'text-success',
            label: "Total Gross Discount",
            isShowSale: true,
            isShowReturn: true,
            isShowSubValue: currency && currency !== BASE_CURRENCY,
            value: formatterCurrency((totalSummary ? totalSummary.total_gross_discount : 0), 'GBP'),
            subValue: formatterCurrency((totalSummary ? totalSummary.pc_total_gross_discount : 0), currency),
            saleValue: formatterCurrency((totalSummary ? totalSummary.total_sales_gross_discount : 0), 'GBP'),
            subSaleValue: formatterCurrency((totalSummary ? totalSummary.pc_total_sales_gross_discount : 0), currency),
            returnValue: formatterCurrency((totalSummary ? totalSummary.total_return_gross_discount : 0), 'GBP'),
            subReturnValue: formatterCurrency((totalSummary ? totalSummary.pc_total_return_gross_discount : 0), currency),
        },
        {
            label: "Total Tax",
            isShowSale: true,
            isShowReturn: true,
            isShowSubValue: currency && currency !== BASE_CURRENCY,
            value: formatter.format(totalSummary ? totalSummary.total_tax_discount : 0),
            subValue: formatterCurrency((totalSummary ? totalSummary.pc_total_tax_discount : 0), currency),
            saleValue: formatterCurrency((totalSummary ? totalSummary.total_sales_tax_discount : 0), 'GBP'),
            subSaleValue: formatterCurrency((totalSummary ? totalSummary.pc_total_sales_tax_discount : 0), currency),
            returnValue: formatterCurrency((totalSummary ? totalSummary.total_return_tax_discount : 0), 'GBP'),
            subReturnValue: formatterCurrency((totalSummary ? totalSummary.pc_total_return_tax_discount : 0), currency),
        },
        {
            label: "Total Net Discount",
            isShowSale: true,
            isShowReturn: true,
            isShowSubValue: currency && currency !== BASE_CURRENCY,
            value: formatter.format(totalSummary ? totalSummary.total_net_discount : 0),
            subValue: formatterCurrency((totalSummary ? totalSummary.pc_total_net_discount : 0), currency),
            saleValue: formatterCurrency((totalSummary ? totalSummary.total_sales_net_discount : 0), 'GBP'),
            subSaleValue: formatterCurrency((totalSummary ? totalSummary.pc_total_sales_net_discount : 0), currency),
            returnValue: formatterCurrency((totalSummary ? totalSummary.total_return_net_discount : 0), 'GBP'),
            subReturnValue: formatterCurrency((totalSummary ? totalSummary.pc_total_return_net_discount : 0), currency),
        },
        // {
        //     textColorClass: 'text-danger',
        //     value: formatter.format(totalSummary ? totalSummary.total_difference : 0),
        //     label: "Difference with Shopify",
        // },
    ];

    return (
        <div className="row" style={{ marginLeft: -6, marginRight: -6 }}>
            {widgetsData.map((widget, index) => (
                <Widget
                    key={index}
                    textColorClass={widget.textColorClass}
                    value={widget.value}
                    subValue={widget.subValue}
                    label={widget.label}
                    isShowSale={widget.isShowSale}
                    isShowReturn={widget.isShowReturn}
                    isShowSubValue={widget.isShowSubValue}
                    saleValue={widget.saleValue}
                    subSaleValue={widget.subSaleValue}
                    returnValue={widget.returnValue}
                    subReturnValue={widget.subReturnValue}
                />
            ))}
        </div>
    );
};

export default DiscountTotalSummary;
